export default (options, setProps = {}) => {

    const v =  {
        name: 'BaseView',
        skip_transition: false,
        cover_visibility_strategy_on_start: {
            type: "hide_all",
            params: {
                selected_ids: ""
            }
        },
        cover_visibility_strategy_on_finish: {
            type: "hide_all",
            params: {
                selected_ids: ""
            }
        },
        cover_focus_color_strategy: {
            type: "none",
            params: {
                selected_ids: ""
            }
        },
        cover_transparency_strategy: {
            type: 'clear',
        },
        floor_separation_strategy: {
            type: 'separate_all',
            params: {
                value: 0
            }
        },
        floor_visibility_strategy_on_start: {
            type: 'show_all',
            params: {
                show_outdoor: true,
                selected_ids: ''
            }
        },
        floor_visibility_strategy_on_finish: {
            type: 'show_all',
            params: {
                show_outdoor: true,
                selected_ids: ''
            }
        },
        floor_transparency_strategy:{
            type: 'all_opaque',
        },
        camera_center_strategy: {
            type: 'center_on_all_floors',
            params: {
                selected_ids: '',
                include_outdoor: false,
                center_override: 'none',
                offset_x: 0,
                offset_y: 0,
                offset_z: 0
            }
        },
        camera_zoom_strategy: {
            type: 'zoom_on_all_floors',
            params: {
                selected_ids: '',
                include_outdoor: false,
                use_tilt: true,
                use_orientation: true,
                use_zoom: false,
                tilt: 31,
                orientation: -9,
                zoom: 0,
                unit_to_floor_zoom_ratio: 0.3,
                margin: 0.4,
            }
        },
        floor_focus_color_strategy:{
            type:'set_on_floors',
            params:{
                selected_ids:[],
                value: 1,
                reverse_selection:false,
                outdoor_value: 1,

            }
        },
        background_color_change_strategy: {
            type: 'none',
            params: {
                value: '#000000'
            }
        },
        camera_control_strategy: {
            type: 'constrain_to_level',
            params: {
                selected_ids: '',
                selected_levels:[0],
                allow_rotation: true,
                allow_zoom: true
            }
        },
        camera_zoom_limit_strategy: {
            type: 'limit',
            params: {
                min_zoom_type: 'none',
                max_zoom_type: "focus_on_level_zoom",
                max_zoom_selected_levels: [0],
                max_zoom_include_outdoor: false,
                min_zoom_selected_ids: '',
                max_zoom_selected_ids: '',
                min_zoom_value: 0,
                max_zoom_value: 0
            }
        },
        placeholder_visibility_strategy_on_start: {
            type: 'show_all',
            params:{}
        },
        placeholder_visibility_strategy_on_finish: {
            type: 'show_all',
            params:{}
        },
        event_strategy: {
            click_on_stores: false,
            click_on_floors: false,
            click_on_buildings: false,
            click_on_covers: false
        }
    }

    for(const [key, val] of Object.entries(setProps))
        _.set(v, key, val);
    return v
}
